import React, { useState } from 'react'

import dayjs from 'dayjs'

import { courses } from './mockData'
import objetoMockProgress from './mockData/Progress'
import {
  Modal,
  Percentage,
  Section,
  SectionCourses,
  SectionProgress,
  ToggleSwitch,
  WelcomeModal,
} from '../components'
import { Spacer } from '../components/global'
import { useUser } from '../context'
import { capitalizeFirstLetter } from '../utilFunctions/transformFunc'

// import CloseSessionModal from '../components/modal/closeSession'
// import TodayModal from '../components/modal/today'

const DashboardPage = () => {
  const { user } = useUser()
  const [status, setStatus] = useState(true)
  const month = capitalizeFirstLetter(dayjs().format('MMMM'))

  return (
    <div>
      <Section title="Mis Cursos" childrenClass="content-childrens">
        <SectionCourses courses={courses} />
      </Section>
      <Spacer height={20} />
      <Section
        title="Mis progreso"
        subtitle={`${month}, ${dayjs().year()}`}
        children={<SectionProgress sectionProgressData={objetoMockProgress} />}
        children2={
          <Percentage percentage={50} description="mas que el anterior" />
        }
      />
      <Spacer height={20} />

      <Spacer height={20} />
      <Section>
        <ToggleSwitch />
      </Section>
      <Spacer height={20} />
      {!user?.form && status && (
        <Modal onClose={() => setStatus(!status)}>
          {/* <CloseSessionModal /> */}
          {/* <TodayModal /> */}
          <WelcomeModal />
        </Modal>
      )}
    </div>
  )
}

export default DashboardPage
